// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"3e3ac305","56":"0768311d","63":"8c329b9d","90":"c6a3556c","270":"20374e1a","409":"f2a369b0","452":"58b68395","469":"728abbd7","512":"4da24d45","936":"39858fd9"}[chunkId] + ".chunk.js";
};